

import axios from "axios";
import AllRoutes from "../../nametitle/AllRoutes";
import { baseUrl } from "../../nametitle/dataUrl";


// Créer un Programme 
export const CreateProgram = (title, coverPicture, description, redirect) => {
  var data = JSON.stringify({
    "title": title,
    "description": description,
    "coverPicture":coverPicture,
    "typeActivity":"programme"
  });
  var config = {
    method: 'post',
    url: `${baseUrl.baseUrl}/api/v1/activites/programmes/`,
    headers: {
      'Authorization': `Bearer ${baseUrl.token}`,
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0'
    },
    data: data
  };
  axios(config)
    .then(function (response) {
      // console.log(JSON.stringify(response.data));
      window.location.reload();
      redirect(`/${AllRoutes.admin}/${AllRoutes.activity}`);
      window.location.reload();
    })
    .catch(function (error) {
      // console.log(error);
    });
}

// Mise ajour du Témoignage
export const UpdateProgram = (id, title,coverPicture, description,visible, redirect) => {
  var data = JSON.stringify({
    "title": title,
    "description": description,
    "coverPicture":coverPicture,
    "visible":visible
  });
  var config = {
    method: 'put',
    url: `${baseUrl.baseUrl}/api/v1/activites/programmes/${id}`,
    headers: {
      'Authorization': `Bearer ${baseUrl.token}`,
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0'
    },
    data: data
  };
  axios(config)
    .then(function (response) {
      // console.log(JSON.stringify(response.data));
      window.location.reload();
      redirect(`/${AllRoutes.admin}/${AllRoutes.activity}`);
      window.location.reload();
    })
    .catch(function (error) {
      // console.log(error);
    });

}










// Recupérer tout les programes
export const LoadAllProgram = (SetState) => {
  axios.get(`${baseUrl.baseUrl}/api/v1/activites/programmes/get/all`, {
    headers: {
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0'
    }
  })
    .then(function (response) {
      // console.log(JSON.stringify(response.data));
      SetState(response.data.data)
    })
    .catch(function (error) {
      // console.log(error);
    });
}


